import {
  makePaginationState,
  makeOffsetPaginationState,
  STATUSES,
  concatUnique,
} from 'app/utils/redux';

import * as t from './types';
import * as storyDetailT from 'app/redux/front/storyDetail/types';

const initialState = {
  followingUsers: makePaginationState(),
  followingUserStories: makePaginationState(),
  readStories: makeOffsetPaginationState(),
  feeds: makePaginationState(),
  likedStories: makePaginationState(),
};

const _likeCommunityPostIterator = (item, id) => {
  if (item.feedObject.id === parseInt(id, 10) && item.feedType === 'post') {
    return {
      ...item,
      feedObject: {
        ...item.feedObject,
        isLiked: !item.feedObject.isLiked,
        likeCount: item.feedObject.isLiked
          ? item.feedObject.likeCount - 1
          : item.feedObject.likeCount + 1,
      },
    };
  }

  return item;
};

export default (state = initialState, action) => {
  switch (action.type) {
    // fetch following users
    case `${t.FETCH_FOLLOWING_USERS}_PENDING`:
      return {
        ...state,
        followingUsers: {
          ...state.followingUsers,
          status: STATUSES.PENDING,
        },
      };
    case `${t.FETCH_FOLLOWING_USERS}_SUCCESS`:
      return {
        ...state,
        followingUsers: {
          ...state.followingUsers,
          status: STATUSES.SUCCESS,
          isLoaded: true,
          pagination: {
            ...action.payload.result,
            items: concatUnique(
              state.followingUsers.pagination.items,
              action.payload.result.items.map((item) => ({
                ...item,
                isLive: false,
              }))
            ).sort((item) => (item.isLive ? -1 : 1)),
          },
        },
      };
    case `${t.FETCH_FOLLOWING_USERS}_ERROR`:
      return {
        ...state,
        followingUsers: {
          ...state.followingUsers,
          status: STATUSES.ERROR,
        },
      };

    case `${t.FETCH_FOLLOWING_FEEDS}_PENDING`:
      return {
        ...state,
        feeds: {
          ...state.feeds,
          status: STATUSES.PENDING,
        },
      };
    case `${t.FETCH_FOLLOWING_FEEDS}_SUCCESS`:
      return {
        ...state,
        feeds: {
          ...state.feeds,
          status: STATUSES.SUCCESS,
          isLoaded: true,
          pagination: {
            ...action.payload.result,
            items: state.feeds.pagination.items.concat(
              action.payload.result.items
            ),
          },
        },
      };
    case `${t.FETCH_FOLLOWING_FEEDS}_ERROR`:
      return {
        ...state,
        feeds: {
          ...state.feeds,
          status: STATUSES.ERROR,
        },
      };

    case t.RESET_FOLLOWING_FEEDS:
      return {
        ...state,
        feeds: makePaginationState(),
      };

    // fetch read stories
    case `${t.FETCH_READ_STORIES}_PENDING`:
      return {
        ...state,
        readStories: {
          ...state.readStories,
          status: STATUSES.PENDING,
        },
      };
    case `${t.FETCH_READ_STORIES}_SUCCESS`:
      return {
        ...state,
        readStories: {
          ...state.readStories,
          status: STATUSES.SUCCESS,
          isLoaded: true,
          pagination: {
            ...action.payload.result,
            items: concatUnique(
              state.readStories.pagination.items,
              action.payload.result.items
            ),
          },
        },
      };
    case `${t.FETCH_READ_STORIES}_ERROR`:
      return {
        ...state,
        readStories: {
          ...state.readStories,
          status: STATUSES.ERROR,
        },
      };

    case `${t.DELETE_READ_STORIES}_SUCCESS`:
      return {
        ...state,
        readStories: {
          ...state.readStories,
          pagination: {
            ...state.readStories.pagination,
            items: state.readStories.pagination.items.filter(
              (item) => !action.meta.storyIds.includes(item.id)
            ),
          },
        },
      };

    // change read stories order type
    case `${t.CHANGE_READ_STORIES_ORDER_TYPE}_PENDING`:
      return {
        ...state,
        readStories: {
          ...state.readStories,
          status: STATUSES.PENDING,
        },
      };
    case `${t.CHANGE_READ_STORIES_ORDER_TYPE}_SUCCESS`:
      return {
        ...state,
        readStories: {
          ...state.readStories,
          status: STATUSES.SUCCESS,
          isLoaded: true,
          pagination: {
            ...action.payload.result,
            items: action.payload.result.items,
          },
        },
      };
    case `${t.CHANGE_READ_STORIES_ORDER_TYPE}_ERROR`:
      return {
        ...state,
        readStories: {
          ...state.readStories,
          status: STATUSES.ERROR,
        },
      };

    // like community
    case `${t.LIKE_COMMUNITY_POST}_SUCCESS`: {
      const { postId } = action.meta;
      return {
        ...state,
        feeds: {
          ...state.feeds,
          pagination: {
            ...state.feeds.pagination,
            items: state.feeds.pagination.items.map((item) =>
              _likeCommunityPostIterator(item, postId)
            ),
          },
        },
      };
    }

    // reset
    case t.RESET_FOLLOWING_USERS:
      return {
        ...state,
        followingUsers: makePaginationState(),
      };

    case t.RESET_FOLLOWING_USER_STORIES:
      return {
        ...state,
        followingUserStories: makePaginationState(),
      };

    case t.RESET_READ_STORIES:
      return {
        ...state,
        readStories: makeOffsetPaginationState(),
      };

    case `${t.FETCH_LIKED_STORIES}_PENDING`:
      return {
        ...state,
        likedStories: {
          ...state.likedStories,
          status: STATUSES.PENDING,
        },
      };
    case `${t.FETCH_LIKED_STORIES}_SUCCESS`:
      return {
        ...state,
        likedStories: {
          status: STATUSES.SUCCESS,
          isLoaded: true,
          pagination: {
            ...action.payload.result,
            items: state.likedStories.pagination.items.concat(
              action.payload.result.items
            ),
          },
        },
      };
    case `${t.FETCH_LIKED_STORIES}_ERROR`:
      return {
        ...state,
        likedStories: {
          ...state.likedStories,
          status: STATUSES.ERROR,
        },
      };

    case `${t.DELETE_LIKED_STORY}_SUCCESS`:
    case `${storyDetailT.DELETE_LIKED_STORY}_SUCCESS`:
      return {
        ...state,
        likedStories: {
          ...state.likedStories,
          pagination: {
            ...state.likedStories.pagination,
            items: state.likedStories.pagination.items.filter(
              (item) => item.id !== action.meta.storyId
            ),
          },
        },
      };

    case `${storyDetailT.LIKE_STORY}_SUCCESS`:
      return {
        ...state,
        likedStories: {
          ...state.likedStories,
          pagination: {
            ...state.likedStories.pagination,
            items: [action.payload.result].concat(
              state.likedStories.pagination.items
            ),
          },
        },
      };

    default:
      return { ...state };
  }
};
export { initialState };



// WEBPACK FOOTER //
// ./src/app/redux/front/library/reducer.js